export default function InputBox({ label, type, placeholder, required, formName, labelStyle, multiline, value, onChange, error}) {
    return (
        <div>
            {label && <label className="form-label fs-base" style={labelStyle} htmlFor="name">{label}</label>}
            {!multiline && <input value={value} onChange={onChange} className="form-control form-control-lg" type={type} placeholder={placeholder} required={required} name={formName} />}
            {multiline && <textarea value={value} onChange={onChange} className="form-control form-control-lg" placeholder={placeholder} rows={multiline}></textarea>}
            {error && <span className="error-label">{error}</span>}
        </div>
    )
}